import { Tag, Tooltip } from "@arco-design/web-react";

import { getProfilePillDisplayLabel } from "../../utils/splitPillLabel";

type Props = {
  label: string;
};

export function ProfileTag({ label }: Props) {
  const displayLabel = getProfilePillDisplayLabel(label);

  return (
    <Tooltip content={label} trigger={["hover", "focus", "click"]}>
      <Tag bordered className="mentor-profile__tag">
        <span className="mentor-profile__tag-inner">{displayLabel}</span>
      </Tag>
    </Tooltip>
  );
}
